module.exports = __webpack_public_path__ + "static/img/apply.6cb1a5be.png";